'use client';
import React, { useState } from 'react';
import { Copy, Check, Zap } from 'lucide-react';
import { toast } from 'sonner';

const FEE_ADDRESS = '37t7eXYbqedv6N6MJC9wgL6N1Ea4FLazc6';

export default function BtcAddressCard() {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard?.writeText(FEE_ADDRESS);
    setCopied(true);
    toast?.success('Bitcoin address copied to clipboard');
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="rounded-xl border border-btcgold-500/20 bg-btcgold-500/5 p-5">
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-lg bg-btcgold-500/15 flex items-center justify-center flex-shrink-0 mt-0.5">
          <Zap size={16} className="text-btcgold-400" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-white">Transaction Fee Address</p>
          <p className="text-xs text-zinc-400 mt-0.5">
            A small fee on every FFCT transaction is routed to this Bitcoin address
          </p>
          <div className="mt-3 flex items-center gap-2">
            <div className="flex-1 min-w-0 bg-zinc-900 border border-zinc-700 rounded-lg px-3 py-2">
              <span className="font-mono text-xs text-btcgold-300 break-all">{FEE_ADDRESS}</span>
            </div>
            <button
              onClick={handleCopy}
              className="flex-shrink-0 p-2 rounded-lg bg-zinc-800 hover:bg-zinc-700 border border-zinc-700 transition-all duration-150 active:scale-95"
              aria-label="Copy Bitcoin address"
            >
              {copied ? (
                <Check size={14} className="text-green-400" />
              ) : (
                <Copy size={14} className="text-zinc-400" />
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}